import { A } from '../actions/documents';
import update from 'immutability-helper';

const initialState = {
  getDocuments: {
    isFetching: false,
    error: null,
  },
  fetchedDocs: null,
};

const items = (state = initialState, action) => {
  switch (action.type) {
    case A.REQUEST_GET_DOCUMENTS:
      return update(state, {
        getDocuments: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_DOCUMENTS:
      return update(state, {
        getDocuments: {
          isFetching: { $set: false },
        },
        fetchedDocs: { $set: action.data },
      });

    case A.ERROR_GET_DOCUMENTS:
      return update(state, {
        getDocuments: {
          isFetching: { $set: true },
          error: { $set: action.err },
        },
      });

    default:
      return state;
  }
};

export default items;
